/**
 * Helpers for {{object.field}} placeholders in campaign step email templates, shared by
 * stack-backend's renderer and the management dashboard's preview of placeholder values.
 */

// {{onboard.onboardId}}, {{ product.name }}, {{onboard.metadata.foo}}
export const EMAIL_TEMPLATE_PLACEHOLDER_REGEX =
  /\{\{\s*([A-Za-z_]\w*(?:\.\w+)*)\s*\}\}/g;

// The value at a dotted path, e.g. "product.code"
export const getPlaceholderValue = (values: unknown, path: string): unknown =>
  path
    .split(".")
    .reduce<unknown>(
      (value, key) =>
        value !== null && typeof value === "object"
          ? (value as Record<string, unknown>)[key]
          : undefined,
      values
    );

// Plain objects and arrays (e.g. {{onboard.metadata}}) have no sensible text. Other objects, like
// Decimal prices and Dates, can be formatted.
export const isMissingPlaceholderValue = (value: unknown): boolean => {
  if (value === undefined || value === null || value === "") return true;
  if (Array.isArray(value)) return true;
  if (typeof value !== "object") return false;
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};
